import React, { useState } from 'react';
import { useTranslation } from '@hooks/useTranslation';
import { Collection } from '@components/common';
import { RefillModal } from '@components/modals';
import './RefillsPage.scss';

export const RefillsPage = () => {
    const { t } = useTranslation();
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [modalState, setModalState] = useState({
        isOpen: false,
        mode: 'edit',
        refill: null
    });

    const handleRefresh = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    const handleModalOpen = (mode, refill = null) => {
        setModalState({
            isOpen: true,
            mode,
            refill
        });
    };

    const handleModalClose = () => {
        setModalState({
            isOpen: false,
            mode: 'edit',
            refill: null
        });
    };

    const handleModalSuccess = () => {
        handleRefresh();
        handleModalClose();
    };

    const getCollectionActions = () => [
        {
            label: t('refill.edit'),
            variant: 'secondary',
            onClick: (refill) => handleModalOpen('edit', refill)
        }
    ];

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleString();
    };


    return (
        <div className="refills-page">
            <div className="refills-page__header">
                <h1 className="refills-page__title">{t('refill.page_title')}</h1>
                <p className="refills-page__description">
                    {t('refill.page_description')}
                </p>
            </div>

            <Collection
                modelName="refills"
                apiEndpoint="refills"
                refreshTrigger={refreshTrigger}
                onRefresh={handleRefresh}
                actions={getCollectionActions()}
                searchFields={['resource.name', 'user.name', 'notes']}
                sortFields={[
                    { key: 'refilled_at', label: t('refill.refilled_date') },
                    { key: 'quantity_added', label: t('refill.quantity_added') }
                ]}
                filterOptions={[
                    {
                        key: 'resource_id',
                        label: t('refill.resource'),
                        type: 'select',
                        endpoint: 'resources'
                    }
                ]}
            />

            <RefillModal
                isOpen={modalState.isOpen}
                onClose={handleModalClose}
                mode={modalState.mode}
                refill={modalState.refill}
                resource={modalState.refill?.resource}
                onSuccess={handleModalSuccess}
            />
        </div>
    );
};

export default RefillsPage;
